import React, { PureComponent } from 'react';
import _ from 'lodash';
import {
    Theme,
    createStyles,
    WithStyles,
    withStyles,
    Typography,
    Grid,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Checkbox,
    TextField,
    FormControlLabel,
    Switch,
    Link
} from '@material-ui/core';
import { statusType } from '../../types/ContentInSection';
import { MyPATExpansionPanel, MyPATMathField, MyPATTextField, AwardGraceMarks, MyPATSelect } from '../../../common';
import ContentFormData from '../../types/ContentFormData';
import ContentFormDataError from '../../types/ContentFormDataError';
import { QUESTION_TYPES, CONTENT_STATES } from '../../../../constants/comman';
import { convertTime } from '../../../../utils/getOffset.utils';
import AddFeedback from '../../../content-request/components/AddFeedback';
import { SectionFocusedContext, SectionFocusedContextValue } from '../../../common/MyPATBaseSection';
import SetIdealTime from './SetIdealTime';
import FillInTheBlanks from './FillInTheBlanks';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import AddFeedbackPopup from './AddFeedbackPopup';
import { SECTIONS } from '../../helper/contentValidation';

const styles = (theme: Theme) =>
  createStyles({
    feedbackContainer: {
      position: "relative",
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    optionsContainer: {
      width: "auto",
      overflow: "auto",
    },
    answerTable: {
      width: "auto",
      marginTop: 15,
      "& tbody": {
        "& tr": {
          height: "auto",
          display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignItems: "center",
          "& td": {
            // padding: `${theme.spacing.unit / 2}px 0`,
            border: 0,
            textAlign: "center",
            minWidth: '70px',
            color: "#333",
            fontSize: 20,
            lineHeight: '38px',
            borderRight: "1px solid rgb(151 151 151 / 42%)",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            height: 45,
            padding: '0 25px',
            width: 130,
            margin: "10px 0",
            "&:last-child": {
              border: 'none',
            },
          },
          "&:first-child": {
            "& td": {
              borderRight: '1px solid rgb(151 151 151 / 42%)',
              fontSize: "20px",
              lineHeight: "38px",
              color: "#333",
            //   padding: '0 40px',
              "&:last-child": {
                borderRight: 0,
              },
              [`&:nth-child(7n + 1)`]: {
                textAlign: "left",
                padding: 0,
                justifyContent: 'flex-start',
              },
            },
          },
        },
      },
    },

    answerBox: {
    //   border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
      "& textarea": {
        border: 0,
        padding: 0,
      },
      "& h6": {
        color: theme.palette.grey[400],
      },
      "& .suggested-box": {
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing.unit,
        width: "100%",
        marginBottom: theme.spacing.unit,
        "&:last-child": {
          marginBottom: 0,
        },
      },
    },

    borderBox: {
      border: "1px solid #E1E1E1",
      boxSizing: "border-box",
      borderRadius: 5,
      backgroundColor: "#fff",
      padding: 8,
      overflow: "auto",
    },

    checkboxChecked: {
      color: "#59CA1C !important",
    },

    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },

    mb1x: {
      marginBottom: theme.spacing.unit,
    },

    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },

    spacingMD: {
      width: "calc(100% + 30px)",
      margin: "-10px 0px 0px",
      padding: "0px 8px",
    },

    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    // Answer Setting
    subTitle: {
      fontSize: 16,
      lineHeight: "22px",
      color: "#666",
      margin: "6px 0 10px 6px",
    },
    blueColor: {
      color: "#1D7DEA",
    },
    optionContainerTxt: {
      // margin: "24px 0 0px -5px",
    },
    posRelative: {
      position: "relative",
    },
    arrowIcon: {
      position: "absolute",
      right: "8px",
      zIndex: 99,
      top: "1px",
    },
    arrowIconT: {
      cursor: "pointer",
    },
    arrowIconB: {
      marginTop: "-10px",
      cursor: "pointer",
    },
    headingTxt: {
      fontSize: "14px",
      lineHeight: "16px",
      color: "#333",
    },
    grayTxt: {
      color: "#999",
    },
    optionSettingText: {
      width: "67px",
      margin: "0px 10px 0 10px",
      textAlign: "center",
      "& input": {
        padding: "10px",
      },
      "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
        opacity: 0,
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        appearance: "none",
      },
    },
    checkedCheckbox: {
      backgroundColor: "#30BE76",
      border: "1px solid #30BE76 !important",
      borderRadius: 2,
      color: "#99a1a7",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 3,
        left: 8,
        width: 4,
        height: 12,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
        
      },
      "&:hover": {
        backgroundColor: "#30BE76",
      },
    },
    checkBoxElement: {
      padding: "0px 7px",
      top: 6,
      width: 24,
      height: 24,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      borderRadius: 2,
      margin: "-15px 16px 0px 6px",
      right: 0,
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
      '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
    }
    },
    primaryColor: {
      color: "rgb(29 125 234)",
    },
    setAnswerContainer: {
      marginBottom: "20px",
    },
    feedbackHighlight: {
      cursor: "pointer",
      "&:hover": {
        color: "#1d7dea",
      },
    },
    weightContainer:{
      '&>div:nth-of-type(1)':{
        height: 48,
        marginLeft: 20,
        '&>div:nth-of-type(1)':{
          height: 48,
          padding: "0 10px",
          border: "1px solid #ccc",
        }
      },
    },
        //   Switch style
        swithMain:{
          marginBottom: 10,
        },
        switchBar:{
          height: 24,
          marginTop: '-12px',
          width: 46,
          borderRadius: 20,
          marginLeft: '-16px',
          backgroundColor: '#fff',
          border: '1px solid #DFDFDF ',             
          // opacity: [[1], '!important'],
  
        },
        IscheckedSwitch:{
          opacity: 1,
          marginRight: '-21px',
          color: '#1d7dea!important',
          marginLeft: '0px!important'
        },
        checkedSwitch:{        
          color: '#D8D8D8', 
          marginRight: '-17px',  
          opacity: 1,   
          // height: 30,
          '& + $switchBar': {
            opacity: 1,
            backgroundColor: 'transparent!important',
            border: '1px solid #DFDFDF',          
          },
        },
        switchIcon:{
          // backgroundColor: '#fff'
          color: '#D8D8D8',
          marginLeft:8,
        },
        optionalFieldText: {
          fontSize: "14px!important",
          color: "#acacac"
        },
        deleteButton: {
          display: 'flex',
          alignItems: 'flex-end',
          cursor: 'pointer',
          height: '100%',
          paddingBottom: 10,
        },
        fillInTheBlanksContainer: {
          display: 'flex',
          "& > .deleteActionButton": {
            height: "38px",
            padding: "8px",
            display: "flex",
            marginLeft: "8px",
            border: "1px solid #CCC",
            borderRadius: "5px",
            cursor: "pointer",
            "& > img": {
              width: "18px"
            },
            "&.visible-false": {
              opacity: 0,
              pointerEvents: "none"
            }
          }
        }
  });

// const optionsIdSet: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
let sections = ['questionContent', 'optionsContent', 'correctAnswer', 'solutionContent', 'questionHints', 'tags', 'conceptCode'];

interface ContentAnswerProps extends WithStyles<typeof styles> {
    setAlternateAnswer: Function,
    changeHandler: Function,
    formData: ContentFormData,
    eventFired: Function,
    formDataError: ContentFormDataError,
    correctAnswer: any,
    optionsContent: any,
    name: string,
    inputId: string,
    type: string,
    subType: string,
    error: boolean,
    errorText: string,
    status: string,
    alternateAnswer: boolean,
    isValidAttempts: boolean,
    idealTime: any,
    onChangeIdealTime: Function;
    tag: string,
    openFeedback: boolean,
    addFeedback: Function,
    replyFeedback: Function,
    closeFeedback: Function,
    resolveFeedback: Function,
    clickedfeedbackData: any,
    addNewFeedback: Function,
    authorType?: string,
    isDisable: boolean,
    isIdealTimeDisabled: boolean;
    customAnswer: boolean;
    updateCustomAnswer: Function;
    hideIdealTIme?: boolean;
    sectionId?: string;
    answerFieldData: number;
    updateBlankField: Function;
    isBlankAnswerFieldTouched: boolean;
    activeValidationFeedbackSection?: string;
    activeValidationFeedbackData?: number;
    handleAddCommentInFeedback?: Function;
    createNewValidationFeedback?: Function;
}

interface ContentAnswerState {
    options: any,
    optionData: any,
    mathEditor: any,
    idealTime: any
}
const integerOptionsSet: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

class ContentAnswer extends PureComponent<ContentAnswerProps, ContentAnswerState> {

    constructor(props: ContentAnswerProps) {
        super(props);
        this.state = {
            optionData: [],
            options: [{}],
            mathEditor: null,
            idealTime: {value: '', state: 1}
        };
        this.isAnswereChecked = this.isAnswereChecked.bind(this);
        this.handleCorrectOptionChangeObj = this.handleCorrectOptionChangeObj.bind(this);
        this.handleCorrectOptionChange = this.handleCorrectOptionChange.bind(this);
        this.setMathInstance = this.setMathInstance.bind(this);
    }

    componentDidMount() {
        this.setState({idealTime: {...this.props.idealTime}})
    }

    setMathInstance = (mathEditor: any) => {
        this.setState({ mathEditor })
    }

    isAnswereChecked(id: string) {
        const { correctAnswer } = this.props;
        let hasId = false;
        _.get(correctAnswer, 'data', []).forEach((ca: any) => {
            if (ca.value == id) {
                hasId = true;
            }
        })

        return hasId;
    }

    updateCorrectAnswer() {
      let { correctAnswer } = this.props;

      const correctAnswerCopy = JSON.parse(JSON.stringify(correctAnswer));

      correctAnswerCopy.data = []
      this.props.changeHandler(correctAnswerCopy);
    }
    handleCorrectOptionChangeObj(e: any, parser = parseFloat) {
        let { optionsContent, correctAnswer, subType } = this.props;
        const correctAnswerCopy = JSON.parse(JSON.stringify(correctAnswer));
        let data: any[] = _.get(correctAnswerCopy, 'data', []);

        const { name, value } = e.target;
        if (data.length) {
            data[0][name] = subType == '6' && value !== "" ? parser(value) : value;
            if(value === "" && subType == "7" && this.props.customAnswer) {
              data = []

            }
        } else {
            data = [{ [name]: subType == '6' && value !== "" ? parser(value) : value }]
        }
        correctAnswerCopy.data = data;
        if (subType == '6' && correctAnswerCopy.data && correctAnswerCopy.data.length && correctAnswerCopy.data[0].value !== '') {
          if (!correctAnswerCopy.data[0].positiveTolerance) {
            correctAnswerCopy.data[0].positiveTolerance = null;
          }
          if (!correctAnswerCopy.data[0].negativeTolerance) {
            correctAnswerCopy.data[0].negativeTolerance = null;
          }
        }
        this.props.changeHandler(correctAnswerCopy);
    }

    handleCorrectOptionChange = (optionId: string | number, evt: any, checked: boolean) => {
        let { optionsContent, correctAnswer, subType, alternateAnswer } = this.props;
        const correctAnswerCopy = JSON.parse(JSON.stringify(correctAnswer));
        if (subType == '8' || alternateAnswer) {
            if (checked) {
                correctAnswerCopy.data.push({ value: optionId });
            } else {
                correctAnswerCopy.data = correctAnswerCopy.data.filter((v: any) => v.value != optionId);
            }
        } else {
            // for smcq
            if (checked) {
                correctAnswerCopy.data = [{ value: optionId }];
            } else {
                correctAnswerCopy.data = [];
            }
        }
        this.props.changeHandler(correctAnswerCopy);
    }

    eventChanges(name: any) {
        if (sections.includes(name))
            this.props.eventFired(name, statusType.edit, 0, 0);
    }

    onlyAllowNumbers = (evt: any, { allowNegative, currentValue } = { allowNegative: false, currentValue: '' }) => {
        var theEvent = evt
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        if(allowNegative) {
            if(key === '-' && !currentValue) {
                return;
            }
        }

        var regex = /[0-9]|\./;
        if(this.props.customAnswer) {
          regex = /^\d+$/;
        }
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    getTimerState(state: number) {
        if(state === 2) return 'min'
        else if(state === 3) return 'hour'
        return 'sec'
    }

    onChangeIdealTime = (e: any, newState?: number) => {
        var regex = /^\d+$/
        let value = e ? e.target.value : this.state.idealTime.value
        if(value === '' || regex.test(value)) {
           value = value ? parseInt(value) : value
            let {state: currState} = this.props.idealTime
            if(newState) {
              currState = newState;
            }
            value = convertTime(
                value, 
                this.getTimerState(e ? currState : this.state.idealTime.state), 
                this.getTimerState(currState))
            value = value ? parseInt(value) : value

            if(currState >= 1 && currState <= 3) {
                if(e) {
                    this.setState({idealTime: {value, state: currState}},
                        () =>  this.props.onChangeIdealTime(value, currState))
                } else {
                    this.props.onChangeIdealTime(value, currState)
                }
            }
        }
    }

    renderIdealTimeState() {
        const {idealTime} = this.props
        if(idealTime.state === 2) {
            return 'Min'
        } else if(idealTime.state === 3) {
            return 'Hour'
        } else if(idealTime.state === 1) {
            return 'Sec'
        }
    }

    handleFillUpAnswerUpdate(answers:any){
      let answersCopy = JSON.parse(JSON.stringify(answers));
      let finalValid = true;
      let isValid = true;
      (answersCopy || []).forEach((ans: any) => {
        let validity = !((ans.value || '').trim().length);
        ans['error'] = validity;
        isValid = !validity;
        finalValid = isValid && finalValid;
      });
      this.props.changeHandler(answersCopy);
    }

    render() {
        const {
            classes,
            optionsContent,
            correctAnswer,
            subType,
            formDataError,
            error,
            errorText,
            status,
            setAlternateAnswer,
            alternateAnswer,
            changeHandler,
            isValidAttempts,
            idealTime,
            isDisable,
            isIdealTimeDisabled,
            customAnswer,
            hideIdealTIme,
            sectionId,
            activeValidationFeedbackSection,
            activeValidationFeedbackData,
            handleAddCommentInFeedback,
            createNewValidationFeedback,
        } = this.props;
        // TODO - find a better way to do this later
        let options = optionsContent
        return (
          <>
            <MyPATExpansionPanel
              isDisable={isDisable}
              hasExpandIcon
              variant="white"
              sectionId={ sectionId } // used for scrolling to this section
              customCollapseTitle={
                <>
                  <Typography
                    variant="h6"
                    className={classes.cardHeading}
                    onClick={(event) => {
                      event.stopPropagation();
                      this.props.addFeedback("answer");
                    }}
                  >
                    <span
                      id={
                        this.props.openFeedback &&
                        this.props.tag === "answer"
                          ? "feedbackScroll"
                          : ""
                      }
                      className={`${classes.feedbackContainer} ${
                        this.props.openFeedback &&
                        this.props.tag === "answer"
                          ? classes.blueColor
                          : ""
                      } ${
                        this.props.openFeedback
                          ? classes.feedbackHighlight
                          : ""
                      }`}
                    >
                      Answer
                      {
                         (<span className={classes.requiredHeading}>*</span>)
                      }
                      
                      {this.props.openFeedback &&
                        this.props.tag === "answer" && (
                          <Grid className="feedbackBlock">
                            <AddFeedback
                              author={this.props.authorType}
                              replyFeedback={this.props.replyFeedback}
                              closeFeedback={this.props.closeFeedback}
                              resolveFeedback={
                                this.props.resolveFeedback
                              }
                              clickedfeedbackData={
                                this.props.clickedfeedbackData
                              }
                              addNewFeedback={this.props.addNewFeedback}
                            />
                          </Grid>
                        )}
                      {
                        activeValidationFeedbackSection === SECTIONS.ANSWER && (
                          <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                        )
                      }
                    </span>
                    <CustomInfoIcon
                      infoDialogContentType="Goal Management"
                      isInfoIcon={true}
                      isRightArrow={false}
                      isCenterArrow={true}
                      knowMoreAbout={false}
                      dialogTitle="Answer"
                      imageURL="/assets/svg/infoIcon/answer.svg"
                      dialogPara="Specify the correct answer(s) to the question"
                      details="Click to know more"
                      toolTipDirection="top" />
                  </Typography>
                </>
              }
              // TODO - work on errors later
              error={error}
              errorText={errorText}
            >
              <SectionFocusedContext.Consumer>
                {({ setSectionFocus }: SectionFocusedContextValue) => (
                  <>
                    <div style={{ marginLeft: "-10px" }}>
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                        spacing={8}
                      >
                        <Grid item style= {{display: "contents"}}>
                          <Typography
                            variant="subtitle1"
                            className={classes.subTitle} style={{fontWeight: 600}}
                          >
                            Set Correct Answer
                          </Typography>
                          {["7"].includes(subType) && (
                            <Grid item>
                              <FormControlLabel
                                control={
                                  <Switch
                                    classes={{
                                      root: classes.swithMain,
                                      icon: classes.switchIcon,
                                      bar: classes.switchBar,
                                      iconChecked:
                                        classes.IscheckedSwitch,
                                      checked: classes.checkedSwitch,
                                      // disabled: classes.disabledSwitch
                                    }}
                                    color="primary"
                                    checked={customAnswer}
                                    onChange={(event) =>{
                                      this.props.updateCustomAnswer(
                                        event.target.checked
                                      );
                                      setTimeout(() => {
                                        this.updateCorrectAnswer()

                                      }, 100)
                                    }
                                    }
                                    // disabled={disableFields || isPreview}
                                  />
                                }
                                label="Custom Answer"
                                labelPlacement="end"
                              />
                            </Grid>
                          )}
                        </Grid>
                        <Grid item>
                          {[
                            QUESTION_TYPES.SMCQ,
                            QUESTION_TYPES.INTEGER,
                          ].includes(parseInt(subType)) &&
                            status === CONTENT_STATES.PUBLISHED &&
                            isValidAttempts && (
                              <AwardGraceMarks
                                alternateAnswer={alternateAnswer}
                                setAlternateAnswer={setAlternateAnswer}
                                correctAnswer={correctAnswer}
                                changeHandler={changeHandler}
                              />
                            )}
                        </Grid>
                      </Grid>
                      <Grid className={classes.setAnswerContainer}>
                        {[
                          QUESTION_TYPES.SMCQ,
                          QUESTION_TYPES.MMCQ,
                          QUESTION_TYPES.TRUE_FALSE,
                        ].includes(parseInt(subType)) && (
                          <Table className={classes.answerTable}>
                            <TableBody>
                              <TableRow>
                                {_.map(options, (option, index) => {
                                  return (
                                    <TableCell key={index}>
                                      <Checkbox
                                        classes={{
                                          root: classes.checkBoxElement,
                                          checked:
                                            classes.checkedCheckbox,
                                          colorPrimary:
                                            classes.primaryColor,
                                        }}
                                        name="correctAnswer"
                                        checked={this.isAnswereChecked(
                                          option.id
                                        )}
                                        onChange={this.handleCorrectOptionChange.bind(
                                          this,
                                          option.id
                                        )}
                                        onFocus={() =>
                                          setSectionFocus(true)
                                        }
                                        onBlur={() =>
                                          setSectionFocus(false)
                                        }
                                      />
                                      {option.id}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            </TableBody>
                          </Table>
                        )}
                        {["7"].includes(subType) &&
                          !this.props.customAnswer && (
                            <Table className={classes.answerTable}>
                              <TableBody>
                                <TableRow>
                                  {_.map(
                                    integerOptionsSet,
                                    (option, index) => {
                                      return (
                                        <TableCell key={index}>
                                          <Checkbox
                                            classes={{
                                              root:
                                                classes.checkBoxElement,
                                              checked:
                                                classes.checkedCheckbox,
                                              colorPrimary:
                                                classes.primaryColor,
                                            }}
                                            name="correctAnswer"
                                            checked={this.isAnswereChecked(
                                              option
                                            )}
                                            // classes={{ checked: classes.checkboxChecked }}
                                            onChange={this.handleCorrectOptionChange.bind(
                                              this,
                                              Number(option)
                                            )}
                                            onFocus={() =>
                                              setSectionFocus(true)
                                            }
                                            onBlur={() =>
                                              setSectionFocus(false)
                                            }
                                          />
                                          {option}
                                        </TableCell>
                                      );
                                    }
                                  )}
                                </TableRow>
                              </TableBody>
                            </Table>
                          )}
                        {["7"].includes(subType) &&
                          this.props.customAnswer && (
                            <div className={classes.answerBox}>
                             <MyPATTextField
                              name="value"
                              placeholder="Enter Answer Here"
                              value={_.get(
                                correctAnswer,
                                "data[0].value",
                                ""
                              )}
                              type={"number"}
                              onChange={(e: any) => {
                                this.handleCorrectOptionChangeObj(e);
                              }}
                              inputProps={{ min: 0, max: 9007199254740991 }}
                              onPaste={(e: any) =>
                                this.onlyAllowNumbers(e, {
                                  allowNegative: false,
                                  currentValue: _.get(
                                    correctAnswer,
                                    "data[0].value",
                                    ""
                                  ),
                                })
                              }

                              onKeyPress={(e: any) =>
                                this.onlyAllowNumbers(e, {
                                  allowNegative: false,
                                  currentValue: _.get(
                                    correctAnswer,
                                    "data[0].value",
                                    ""
                                  ),
                                })
                              }
                              fullWidthControl
                              endAdornment={<></>}
                            />
                            </div>
                          )}
                        {["4"].includes(subType) && (
                          <div className={classes.answerBox}>
                            <MyPATMathField
                              gridSize={12}
                              variant="textarea"
                              editorProps={{
                                externalToolbarId: "box",
                                name: "value",
                                placeholder: "Enter Answer here",
                                value: _.get(
                                  correctAnswer,
                                  "data[0].value",
                                  ""
                                ),
                                editorId: "answerText",
                                handleChange: this
                                  .handleCorrectOptionChangeObj,
                                setInstance: this.setMathInstance,
                              }}
                            />
                          </div>
                        )}

                        {["6"].includes(subType) && (
                          <>
                            <MyPATTextField
                              name="value"
                              placeholder="Enter Answer Here"
                              value={_.get(
                                correctAnswer,
                                "data[0].value",
                                ""
                              )}
                              type={"number"}
                              onChange={(e: any) => {
                                this.handleCorrectOptionChangeObj(e);
                              }}
                              onKeyPress={(e: any) =>
                                this.onlyAllowNumbers(e, {
                                  allowNegative: true,
                                  currentValue: _.get(
                                    correctAnswer,
                                    "data[0].value",
                                    ""
                                  ),
                                })
                              }
                              fullWidthControl
                              endAdornment={<></>}
                            />
                            <Grid container spacing={8}>
                              <Grid item xs={6}>
                                <MyPATTextField
                                  value={_.get(
                                    correctAnswer,
                                    "data[0].positiveTolerance",
                                    ""
                                  )}
                                  name="positiveTolerance"
                                  type="number"
                                  placeholder="Positive Tolerance"
                                  inputProps={{ min: "0" }}
                                  onChange={(e: any) => {
                                    this.handleCorrectOptionChangeObj(
                                      e
                                    );
                                  }}
                                  onKeyPress={this.onlyAllowNumbers}
                                  fullWidthControl
                                  endAdornment={<></>}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={6}
                                style={{ display: "flex" }}
                              >
                                <MyPATTextField
                                  value={"-"}
                                  name="negativeTolerancePrefix"
                                  type="text"
                                  style={{ width: "40px" }}
                                />
                                <MyPATTextField
                                  value={_.get(
                                    correctAnswer,
                                    "data[0].negativeTolerance",
                                    ""
                                  )}
                                  name="negativeTolerance"
                                  type="number"
                                  placeholder="Negative Tolerance"
                                  inputProps={{ min: 0 }}
                                  onChange={(e: any) => {
                                    this.handleCorrectOptionChangeObj(
                                      e
                                    );
                                  }}
                                  onKeyPress={this.onlyAllowNumbers}
                                  fullWidthControl
                                  endAdornment={<></>}
                                />
                              </Grid>
                            </Grid>
                          </>
                        )}
                        {["3"].includes(subType) && (
                          <FillInTheBlanks parentClass={classes.fillInTheBlanksContainer} availableAnswers={Array.isArray(this.props.correctAnswer) ? (this.props.correctAnswer) : (this.props.correctAnswer || {}).data || []} onAnswerUpdate={this.handleFillUpAnswerUpdate.bind(this)}></FillInTheBlanks>
                        )}
                      </Grid>
                    </div>
                    {/* Set Ideal time */}
                  </>
                )}
              </SectionFocusedContext.Consumer>
            </MyPATExpansionPanel>
           {!hideIdealTIme && 
            <SetIdealTime
              addFeedback={this.props.addFeedback}
              openFeedback={this.props.openFeedback}
              tag={this.props.tag}
              idealTime={this.props.idealTime}
              checkFeedback={() =>
                this.props.openFeedback &&
                this.props.tag === "idealTime"
              }
              isDisable={isIdealTimeDisabled}
              onChangeIdealTime={this.onChangeIdealTime}
              authorType={this.props.authorType}
              replyFeedback={this.props.replyFeedback}
              closeFeedback={this.props.closeFeedback}
              resolveFeedback={this.props.resolveFeedback}
              clickedfeedbackData={this.props.clickedfeedbackData}
              addNewFeedback={this.props.addNewFeedback}
            />}
          </>
        );
    }
}

// @ts-ignore
export default withStyles(styles)(ContentAnswer);